import { resolveLocation, resolveViewport } from "@citychallenge/common";
import { DEFAULT_COORD } from "@citychallenge/common";
import {
  getBoundingBoxOfPoint,
  resolveBoundingBox,
} from "@citychallenge/common";
import { useMemo } from "react";

export function useGamesMapCamera(
  locations: number[][],
  options: {
    width: number;
    height: number;
    insetTop?: number;
    insetBottom?: number;
    spacing?: number;
  }
) {
  const bounds = useMemo(() => {
    if (!locations.length) return undefined;

    if (!locations.length) return getBoundingBoxOfPoint(DEFAULT_COORD, 500);

    if (locations.length === 1) return getBoundingBoxOfPoint(locations[0], 500);

    return resolveBoundingBox(...locations);
  }, [locations]);

  const { width, height } = options;

  const camera = useMemo(() => {
    if (!bounds) return undefined;

    const { insetTop = 0, insetBottom = 0, spacing = 40 } = options;

    // Add 15 to inset to top because marker is ~30 px height (this centers the
    // marker better)
    const paddingTop = insetTop + spacing * 2 + 15;
    const paddingBottom = insetBottom + spacing * 2;

    // Add 30 to horizontal spacing to offset markers
    const spacingHorizontal = spacing * 2 + 30;

    const availableHeight = Math.max(height - paddingTop - paddingBottom, 50);

    const viewPort = resolveViewport(bounds, [
      width - spacingHorizontal,
      availableHeight,
    ]);

    return {
      paddingTop,
      paddingBottom,
      center: resolveLocation(viewPort.center),
      zoom: viewPort.zoom,
    };
  }, [
    bounds,
    options.width,
    options.height,
    options.insetBottom,
    options.insetTop,
    options.spacing,
  ]);
  return camera;
}
